import { render, staticRenderFns } from "./TreeNodeCourseInfo.vue?vue&type=template&id=811c33de&"
import script from "./TreeNodeCourseInfo.vue?vue&type=script&lang=js&"
export * from "./TreeNodeCourseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports